<template>
  <!-- 头部组件 -->
  <div class="container">
    <el-row type="flex" justify="space-between">
      <div class="wrap">
        <div class="logo hand" @click="toHome">
          <img src="../../assets/imgs/logo00.png" alt="" />
        </div>
        <div class="flex">
          <!-- PC端搜索框 -->
          <div class="home-search">
            <el-input
              placeholder="请输入"
              v-model="search"
              class="input-with-select"
              size="medium"
              @keyup.enter.native="toSearchPage"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="toSearchPage"
              ></el-button>
            </el-input>
          </div>
          <!-- PC端登录注册 -->
          <div class="login hand">
            <router-link to="/login" tag="span"
              ><span v-show="ifIn"
                ><i class="el-icon-user"></i>登录</span
              ></router-link
            >
            <el-dropdown v-show="!ifIn" trigger="click">
              <span class="el-dropdown-link"
                ><i class="el-icon-user"></i
                ><span style="margin-right: 6px">{{ email }}</span
                ><el-badge
                  :value="messageNum"
                  class="item"
                  style="position: relative; top: 4px; left: -2px"
                  :hidden="hidden"
                ></el-badge
                ><i class="el-icon-arrow-down"></i
              ></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  ><router-link to="/userinfo" tag="div"
                    >基本信息</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/myRegisterList" tag="div"
                    >我的注册</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/message" tag="div"
                    >我的消息<el-badge
                      :value="messageNum"
                      class="item"
                      style="margin-left: 8px"
                    ></el-badge></router-link
                ></el-dropdown-item>
                <el-dropdown-item @click.native="toExit">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="register fr hand" v-if="ifIn">
              <router-link to="/register" tag="div">
                <div>
                  <span class="el-dropdown-link"
                    ><i class="el-icon-edit-outline"></i>注册</span
                  >
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <!-- 移动端菜单 -->
    <el-row class="phone-menu hidden-sm-and-up">
      <ul>
        <li v-if="homeMenu" @click="toHiddenOthers('home')">
          <router-link
            to="/home"
            tag="li"
            :class="{ active: activeName === 'home' }"
            >中心首页</router-link
          >
        </li>
        <li v-if="centerMenu" @click="toHiddenOthers('center')">
          <router-link
            to="/center"
            tag="li"
            :class="{ active: activeName === 'center' }"
            >中心概况</router-link
          >
        </li>
        <li v-if="dynamicMenu" @click="toHiddenOthers('dynamic')">
          <router-link
            to="/new"
            tag="li"
            :class="{ active: activeName === 'dynamic' }"
            >循证动态</router-link
          >
        </li>
        <li v-if="resourceMenu" @click="toHiddenOthers('resource')">
          <router-link
            to="/resource/recommend"
            tag="li"
            :class="{ active: activeName === 'resource' }"
            >循证实践资源区</router-link
          >
        </li>
        <li v-if="schoolMenu" @click="toHiddenOthers('school')">
          <router-link
            to="/school/quality"
            tag="li"
            :class="{ active: activeName === 'school' }"
            >循证学苑</router-link
          >
        </li>
        <li v-if="registerMenu" @click="toHiddenOthers('register')">
          <router-link
            to="/summary/info"
            tag="li"
            :class="{ active: activeName === 'register' }"
            >循证注册平台</router-link
          >
        </li>
      </ul>
    </el-row>
    <!-- PC端菜单 -->
    <div class="menu">
      <div class="hidden-xs-only">
        <div class="menu-wrap">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            active-text-color="#fdff43"
            text-color="#fff"
            background-color="#3c55cc"
          >
            <el-menu-item index="1"
              ><router-link to="/home" tag="li"
                >中心首页</router-link
              ></el-menu-item
            >
            <el-menu-item index="2"
              ><router-link to="/center" tag="li"
                >中心概况</router-link
              ></el-menu-item
            >
            <el-menu-item index="3"
              ><router-link to="/new" tag="li"
                >循证动态</router-link
              ></el-menu-item
            >
            <el-submenu index="4">
              <template slot="title">循证实践资源区</template>
              <el-menu-item index="4-1"
                ><router-link to="/resource/recommend" tag="li"
                  >系统评价</router-link
                ></el-menu-item
              >
              <el-menu-item index="4-2"
                ><router-link to="/resource/summary" tag="li"
                  >证据总结</router-link
                ></el-menu-item
              >
              <el-menu-item index="4-3"
                ><router-link to="/resource/guide" tag="li"
                  >指南</router-link
                ></el-menu-item
              >
              <el-menu-item index="4-4"
                ><router-link to="/resource/application" tag="li"
                  >证据应用</router-link
                ></el-menu-item
              >
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">循证学苑</template>
              <el-menu-item index="5-1"
                ><router-link to="/school/quality" tag="li"
                  >文献质量评价工具</router-link
                ></el-menu-item
              >
              <el-menu-item index="5-2"
                ><router-link to="/school/integratedApproach" tag="li"
                  >证据综合方法学</router-link
                ></el-menu-item
              >
              <el-menu-item index="5-3"
                ><router-link to="/school/applicationMethods" tag="li"
                  >证据应用方法学</router-link
                ></el-menu-item
              >
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">循证注册平台</template>
              <el-menu-item index="6-1"
                ><router-link to="/summary" tag="li"
                  >证据总结注册</router-link
                ></el-menu-item
              >
              <el-menu-item index="6-2"
                ><router-link to="/application" tag="li"
                  >证据应用注册</router-link
                ></el-menu-item
              >
              <el-menu-item index="6-3"
                ><router-link to="/registerResources" tag="li"
                  >注册资源</router-link
                ></el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "../../utils/utils";
export default {
  name: "MyComponent",
  props: {},
  data() {
    return {
      hidden: false, //我的消息是否隐藏
      messageNum: null, //我的消息条数
      email: "", //用户邮箱
      ifIn: false, //用户是否登录
      activeIndex: "1", //导航高亮显示
      search: "", //搜索内容
      //导航是否显示
      homeMenu: true,
      centerMenu: false,
      dynamicMenu: false,
      resourceMenu: false,
      schoolMenu: false,
      registerMenu: false,
      activeName: "", //导航激活样式
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path.indexOf("/home") != -1) {
          this.activeIndex = "1";
        } else if (val.path.indexOf("/center") != -1) {
          this.activeIndex = "2";
        } else if (
          val.path.indexOf("/new") != -1 ||
          val.query.name == "循证动态"
        ) {
          this.activeIndex = "3";
          this.activeName = "dynamic";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = true;
          this.resourceMenu = false;
          this.schoolMenu = false;
          this.registerMenu = false;
        } else if (
          val.path.indexOf("/resource/recommend") != -1 ||
          val.query.name == "系统评价"
        ) {
          this.activeIndex = "4-1";
          this.bus.$emit("menuName", "recommend");
          this.activeName = "resource";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = false;
          this.resourceMenu = true;
          this.schoolMenu = false;
          this.registerMenu = false;
        } else if (
          val.path.indexOf("/resource/summary") != -1 ||
          val.query.name == "证据总结"
        ) {
          this.activeIndex = "4-2";
          this.bus.$emit("menuName", "summary");
          this.activeName = "resource";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = false;
          this.resourceMenu = true;
          this.schoolMenu = false;
          this.registerMenu = false;
        } else if (
          val.path.indexOf("/resource/guide") != -1 ||
          val.query.name == "指南"
        ) {
          this.activeIndex = "4-3";
          this.bus.$emit("menuName", "guide");
          this.activeName = "resource";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = false;
          this.resourceMenu = true;
          this.schoolMenu = false;
          this.registerMenu = false;
        } else if (
          val.path.indexOf("/resource/application") != -1 ||
          val.query.name == "证据应用"
        ) {
          this.activeIndex = "4-4";
          this.bus.$emit("menuName", "application");
          this.activeName = "resource";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = false;
          this.resourceMenu = true;
          this.schoolMenu = false;
          this.registerMenu = false;
        } else if (
          val.path.indexOf("/school/quality") != -1 ||
          val.query.name == "文献质量评价工具"
        ) {
          this.activeIndex = "5-1";
          this.bus.$emit("menuName", "quality");
          this.activeName = "school";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = false;
          this.resourceMenu = false;
          this.schoolMenu = true;
          this.registerMenu = false;
        } else if (
          val.path.indexOf("/school/integratedApproach") != -1 ||
          val.query.name == "证据综合方法学"
        ) {
          this.activeIndex = "5-2";
          this.bus.$emit("menuName", "integratedApproach");
          this.activeName = "school";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = false;
          this.resourceMenu = false;
          this.schoolMenu = true;
          this.registerMenu = false;
        } else if (
          val.path.indexOf("/school/applicationMethods") != -1 ||
          val.query.name == "证据应用方法学"
        ) {
          this.activeIndex = "5-3";
          this.bus.$emit("menuName", "applicationMethods");
          this.activeName = "school";
          this.homeMenu = false;
          this.centerMenu = false;
          this.dynamicMenu = false;
          this.resourceMenu = false;
          this.schoolMenu = true;
          this.registerMenu = false;
        } else if (val.path.indexOf("/summary/info") != -1) {
          this.activeIndex = "6-1";
        } else if (val.path.indexOf("/application") != -1) {
          this.activeIndex = "6-2";
        } else if (val.path.indexOf("/registerResources") != -1) {
          this.activeIndex = "6-3";
        } else {
          this.activeIndex = "";
          this.activeName = "";
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    this.bus.$on("messageNum", (val) => {
      this.hidden = val;
      // console.log(this.hidden);
    });
    this.ifUserLogin();
    if (this.$route.path.indexOf("/home") != -1) {
      this.activeIndex = "1";
      this.activeName = "home";
    } else if (this.$route.path.indexOf("/center") != -1) {
      this.activeIndex = "2";
    } else if (this.$route.path.indexOf("/new") != -1) {
      this.activeIndex = "3";
    } else if (this.$route.path.indexOf("/resource/recommend") != -1) {
      this.activeIndex = "4-1";
    } else if (this.$route.path.indexOf("/resource/summary") != -1) {
      this.activeIndex = "4-2";
    } else if (this.$route.path.indexOf("/resource/guide") != -1) {
      this.activeIndex = "4-3";
    } else if (this.$route.path.indexOf("/resource/application") != -1) {
      this.activeIndex = "4-4";
    } else if (this.$route.path.indexOf("/school/quality") != -1) {
      this.activeIndex = "5-1";
    } else if (this.$route.path.indexOf("/school/integratedApproach") != -1) {
      this.activeIndex = "5-2";
    } else if (this.$route.path.indexOf("/school/applicationMethods") != -1) {
      this.activeIndex = "5-3";
    } else if (this.$route.path.indexOf("/summary/info") != -1) {
      this.activeIndex = "6-1";
    } else if (this.$route.path.indexOf("/application") != -1) {
      this.activeIndex = "6-2";
    } else if (this.$route.path.indexOf("/registerResources") != -1) {
      this.activeIndex = "6-3";
    } else {
      this.activeIndex = "";
      this.activeName = "";
    }
  },
  methods: {
    /**获取用户消息列表 */
    getMessageList() {
      let params = {};
      this.httpPost("/message/v1/unreadMessage", params).then((res) => {
        if (res.code == 0) {
          if (res.data != 0) {
            this.messageNum = res.data;
          }
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    /**回到首页 */
    toHome() {
      if (this.$route.path != "/home") {
        this.$router.push("/home");
        this.activeName = "home";
        this.homeMenu = true;
        this.centerMenu = false;
        this.dynamicMenu = false;
        this.resourceMenu = false;
        this.schoolMenu = false;
        this.registerMenu = false;
      }
    },
    /**搜索事件*/
    toSearchPage() {
      if (this.$route.path != "/search") {
        // this.toSearch();
        this.$router.push({ path: "/search", query: { search: this.search } });
      }
    },
    /**移动端是否隐藏其他导航 */
    toHiddenOthers(menuName) {
      this.activeName = menuName;
      if (menuName === "home") {
        this.centerMenu = !this.centerMenu;
        this.dynamicMenu = !this.dynamicMenu;
        this.resourceMenu = !this.resourceMenu;
        this.schoolMenu = !this.schoolMenu;
        this.registerMenu = !this.registerMenu;
      } else if (menuName === "center") {
        this.homeMenu = !this.homeMenu;
        this.dynamicMenu = !this.dynamicMenu;
        this.resourceMenu = !this.resourceMenu;
        this.schoolMenu = !this.schoolMenu;
        this.registerMenu = !this.registerMenu;
      } else if (menuName === "dynamic") {
        this.homeMenu = !this.homeMenu;
        this.centerMenu = !this.centerMenu;
        this.resourceMenu = !this.resourceMenu;
        this.schoolMenu = !this.schoolMenu;
        this.registerMenu = !this.registerMenu;
      } else if (menuName === "resource") {
        this.homeMenu = !this.homeMenu;
        this.centerMenu = !this.centerMenu;
        this.dynamicMenu = !this.dynamicMenu;
        this.schoolMenu = !this.schoolMenu;
        this.registerMenu = !this.registerMenu;
      } else if (menuName === "school") {
        this.homeMenu = !this.homeMenu;
        this.centerMenu = !this.centerMenu;
        this.dynamicMenu = !this.dynamicMenu;
        this.resourceMenu = !this.resourceMenu;
        this.registerMenu = !this.registerMenu;
      } else if (menuName === "register") {
        this.homeMenu = !this.homeMenu;
        this.centerMenu = !this.centerMenu;
        this.dynamicMenu = !this.dynamicMenu;
        this.resourceMenu = !this.resourceMenu;
        this.schoolMenu = !this.schoolMenu;
      }
    },
    /**判断用户是否登录 */
    ifUserLogin() {
      this.token = this.$cookies.get("nursing_tokenWeb");
        this.email = "个人中心";
      if (this.token) {
        this.ifIn = false;
        this.getMessageList();
      } else {
        this.ifIn = true;
      }
    },
    /**退出 */
    toExit() {
      //退出清除登录的cookie值
      this.httpPost("/user/v1/signOut").then((res) => {
        if (res.code == 0) {
          this.ifIn = true;
          this.$cookies.remove("nursing_tokenWeb");
          this.$cookies.remove("nursing_userInfo");
          this.$message({
            message: "退出成功",
            type: "success",
          });
          this.$router.push("/home");
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    /**搜索 */
    toSearch: debounce(function (val, boolean = true) {
      let params = {
        type: this.value,
        key: this.search,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.httpPost("/news/v1/queryNewsInfo", params).then((res) => {
        if (res.code == 0) {
          // console.log("res", res);
          this.searchList = res.data.data;
          if (this.searchList.length === 0) {
            this.infoSearch = false;
          } else {
            this.infoSearch = true;
          }
          this.total = res.data.total;
          this.pageNum = res.data.pageNum;
          this.pageSize = res.data.pageSize;
          if (this.searchList.length < this.pageSize) {
            this.ifHasPages = false;
          } else {
            this.ifHasPages = true;
          }
          this.startNum = (this.pageNum - 1) * this.pageSize + 1;
          // console.log("this.startNum", this.startNum);
          this.endNum = this.startNum + res.data.data.length;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    }, 500),
  },
};
</script>
<style scoped>
.home-search >>> .el-input-group__append,
.el-input-group__prepend {
  background-color: #f5f7fa;
  color: #909399;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border-radius: 0px 4px 4px 0px;
  padding: 0 8px;
  width: 1px;
  white-space: nowrap;
}
</style>
<style scoped lang="less">
@primary-color: #3c55cc;
@hover-color: #2539a1;
a {
  text-decoration: none;
}
/deep/.home-search .el-input-group__append,
.el-input-group__prepend {
  background-color: @primary-color;
  color: #fff;
}
/deep/.home-search .el-input-group__append:hover {
  background-color: @hover-color;
}
/deep/.el-submenu {
  i {
    color: #fff;
  }
}
/deep/.el-submenu.is-active {
  i {
    color: #fdff43;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 359px) {
  @click-color: #fdff43;
  .active {
    color: @click-color!important;
  }
  .container {
    align-items: center;
    .wrap {
      width: 100%;
      padding: 0px 20px;
      margin: 0 auto;
      margin-top: 12px;
      margin-bottom: 12px;
      .logo {
        img {
          height: 32px;
        }
      }
      .flex {
        .login {
          float: right;
          padding: 20px 0px 4px 0px;
          i {
            margin-right: 8px;
          }
        }
        .register {
          float: right;
          margin-left: 12px;
          i {
            margin-right: 8px;
          }
        }
        .home-search {
          width: 280px;
          padding-top: 16px;
        }
      }
    }
    .phone-menu {
      li {
        width: 100vw;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-color: #3c55cc;
        color: #fff;
        border-bottom: 1px solid #fff;
      }
    }
  }
}
@media screen and (min-width: 360px) and (max-width: 410px) {
  @click-color: #fdff43;
  .active {
    color: @click-color!important;
  }
  .container {
    align-items: center;
    .wrap {
      width: 100%;
      padding: 0px 20px;
      height: 100px;
      margin: 0 auto;
      margin-top: 12px;
      margin-bottom: 12px;
      .logo {
        img {
          height: 35px;
        }
      }
      .flex {
        display: flex;
        .login {
          float: right;
          height: 68px;
          margin-left: 4px;
          line-height: 68px;
          i {
            margin-right: 8px;
          }
        }
        .register {
          float: right;
          margin-left: 12px;
          i {
            margin-right: 8px;
          }
        }
        .home-search {
          flex: 1;
          padding-top: 16px;
          height: 68px;
        }
      }
    }
    .phone-menu {
      li {
        width: 100vw;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-color: #3c55cc;
        color: #fff;
        border-bottom: 1px solid #fff;
      }
    }
  }
}
@media screen and (min-width: 411px) and (max-width: 767px) {
  @click-color: #fdff43;
  .active {
    color: @click-color!important;
  }
  .container {
    align-items: center;
    .wrap {
      width: 100%;
      padding: 0px 20px;
      height: 100px;
      margin: 0 auto;
      margin-top: 12px;
      margin-bottom: 12px;
      .logo {
        img {
          height: 42px;
        }
      }
      .flex {
        display: flex;
        .login {
          float: right;
          height: 68px;
          margin-left: 32px;
          line-height: 68px;
          i {
            margin-right: 8px;
          }
        }
        .register {
          float: right;
          margin-left: 12px;
          i {
            margin-right: 8px;
          }
        }
        .home-search {
          flex: 1;
          padding-top: 16px;
          height: 68px;
        }
      }
    }
    .phone-menu {
      li {
        width: 100vw;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-color: #3c55cc;
        color: #fff;
        border-bottom: 1px solid #fff;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .container {
    align-items: center;
    .wrap {
      width: 100%;
      padding: 0px 20px;
      height: 132px;
      margin: 0 auto;
      margin-top: 12px;
      margin-bottom: 12px;
      .logo {
        width: 600px;
        img {
          height: 68px;
        }
      }
      .flex {
        display: flex;
        .login {
          float: right;
          height: 68px;
          margin-left: 32px;
          line-height: 68px;
          i {
            margin-right: 8px;
          }
        }
        .register {
          float: right;
          margin-left: 12px;
          i {
            margin-right: 8px;
          }
        }
        .home-search {
          // position: absolute;
          // left: 600px;
          flex: 1;
          padding-top: 16px;
          height: 68px;
        }
      }
    }
    .menu {
      background: #3c55cc;
      .menu-wrap {
        margin: 0 auto;
      }
    }
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .container {
    align-items: center;
    .wrap {
      width: 100%;
      padding: 0 20px;
      height: 68px;
      margin: 0 auto;
      margin-top: 12px;
      margin-bottom: 12px;
      .logo {
        float: left;
        img {
          height: 55px;
        }
      }
      .flex {
        float: right;
        display: flex;
        .login {
          float: right;
          height: 68px;
          margin-left: 32px;
          line-height: 68px;
          i {
            margin-right: 8px;
          }
        }
        .register {
          float: right;
          margin-left: 12px;
          i {
            margin-right: 8px;
          }
        }
        .home-search {
          flex: 1;
          padding-top: 16px;
          height: 68px;
        }
      }
    }
    .menu {
      background: #3c55cc;
      .menu-wrap {
        margin: 0 auto;
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .container {
    align-items: center;
    .wrap {
      width: 1200px;
      height: 68px;
      margin: 0 auto;
      margin-top: 12px;
      margin-bottom: 12px;
      .logo {
        float: left;
        width: 600px;
        img {
          height: 68px;
        }
      }
      .flex {
        width: 600px;
        float: right;
        display: flex;
        .login {
          float: right;
          height: 68px;
          margin-left: 32px;
          line-height: 68px;
          i {
            margin-right: 8px;
          }
        }
        .register {
          float: right;
          margin-left: 12px;
          i {
            margin-right: 8px;
          }
        }
        .home-search {
          // position: absolute;
          // left: 600px;
          flex: 1;
          padding-top: 16px;
          height: 68px;
        }
      }
    }
    .menu {
      background: #3c55cc;
      .menu-wrap {
        width: 1200px;
        margin: 0 auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Head.vue